const ZENDESK_BASE_URL = 'https://norwegian940.zendesk.com/hc/en-gb/requests/new';
const FORM_ID = '41077901231377';

/**
 * Formats date to YYYY-MM-DD format
 * Handles both YYYYMMDD and YYYY-MM-DD input formats
 */
const formatDate = (date) => {
  if (!date) return '';
  if (date.includes('-')) return date;
  if (date.length === 8) {
    return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
  }
  return date;
};

/**
 * Formats aircraft registration to XX-XXX format
 * Handles both LNXXX and LN-XXX input formats
 */
const formatRegistration = (registration) => {
  if (!registration) return '';
  if (registration.includes('-')) return registration;
  if (registration.length >= 3) {
    return `${registration.slice(0, 2)}-${registration.slice(2)}`;
  }
  return registration;
};

/**
 * Builds a pre-filled Zendesk Cleaning Check form URL
 */
export const buildCleaningCheckUrl = ({
  isCabinCrew,
  departureAirport,
  flightDate,
  flightNumber,
  aircraftRegistration,
}) => {
  const params = new URLSearchParams({
    ticket_form_id: FORM_ID,
    tf_subject: 'Cleaning Check',
    tf_41101387550225: departureAirport || '',                    // Airport IATA
    tf_41077804426897: formatDate(flightDate),                    // Date (YYYY-MM-DD)
    tf_41077390813969: flightNumber || '',                        // Flight number (DX1234)
    tf_41077482780817: formatRegistration(aircraftRegistration),  // Registration (LN-ABC)
    tf_41077624201361: isCabinCrew
      ? 'user_type_field_field_cabin'
      : 'user_type_field_cockpit',                                // Cockpit/Cabin dropdown
  });
  return `${ZENDESK_BASE_URL}?${params.toString()}`;
};

